/* PurePetZone — pagina «Traccia il tuo ordine» (sezione ppz-traccia-ordine), al posto di Track123.

   Disegna il risultato che arriva dal server ppz-traccia (Worker Cloudflare) copiando la pagina
   Track123 com'era il 01/11/2026: «Ordine: #…», stato grande, barra dei passi, «Dettagli della
   spedizione» raggruppati per giorno (prime 3 righe, poi «Mostra cronologia»), «Informazioni sul
   pacco» con la mappa della città di arrivo e il contenuto con «Riordina».

   Indirizzi: ?nums=CODICE apre la linguetta del tracciamento e cerca da solo (lo usano le email di
   spedizione). L'email o il telefono non vanno MAI nell'indirizzo. */

(function () {
  'use strict';

  var radice = document.querySelector('[data-ppz-traccia]');
  if (!radice) return;
  var API = radice.getAttribute('data-api');
  var risultato = radice.querySelector('[data-risultato]');

  var ICONE = {
    "ordinato": "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.97553 3.5C5.6124 3.5 4.45499 4.49858 4.25522 5.84699L3.59447 10.3071C3.53158 10.7316 3.5 11.1602 3.5 11.5894V13.25C3.5 15.0449 4.95507 16.5 6.75 16.5H13.25C15.0449 16.5 16.5 15.0449 16.5 13.25V11.5894C16.5 11.1602 16.4684 10.7316 16.4055 10.3071L15.7448 5.84699C15.545 4.49858 14.3876 3.5 13.0245 3.5H6.97553ZM5.73903 6.06681C5.82983 5.4539 6.35593 5 6.97553 5H13.0245C13.6441 5 14.1702 5.4539 14.261 6.06681L14.8437 10H12.3604C11.8223 10 11.3447 10.3443 11.1745 10.8547L11.0164 11.3291C10.9824 11.4311 10.8868 11.5 10.7792 11.5H9.22076C9.11315 11.5 9.01762 11.4311 8.98359 11.3291L8.82547 10.8547C8.65533 10.3443 8.17766 10 7.63962 10H5.15633L5.73903 6.06681ZM5.00055 11.5C5.00018 11.5298 5 11.5596 5 11.5894V13.25C5 14.2165 5.7835 15 6.75 15H13.25C14.2165 15 15 14.2165 15 13.25V11.5894C15 11.5596 14.9998 11.5298 14.9994 11.5H12.5406L12.4394 11.8034C12.2012 12.518 11.5325 13 10.7792 13H9.22076C8.46751 13 7.79876 12.518 7.56056 11.8034L7.45943 11.5H5.00055Z\" fill=\"currentColor\"></path></svg>",
    "fatto": "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.7803 5.96967C16.0732 6.26256 16.0732 6.73744 15.7803 7.03033L9.28033 13.5303C8.98744 13.8232 8.51256 13.8232 8.21967 13.5303L4.96967 10.2803C4.67678 9.98744 4.67678 9.51256 4.96967 9.21967C5.26256 8.92678 5.73744 8.92678 6.03033 9.21967L8.75 11.9393L14.7197 5.96967C15.0126 5.67678 15.4874 5.67678 15.7803 5.96967Z\" fill=\"currentColor\"></path></svg>",
    "pronto": "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.2803 9.21967C13.5732 9.51256 13.5732 9.98744 13.2803 10.2803L9.78033 13.7803C9.48744 14.0732 9.01256 14.0732 8.71967 13.7803L6.96967 12.0303C6.67678 11.7374 6.67678 11.2626 6.96967 10.9697C7.26256 10.6768 7.73744 10.6768 8.03033 10.9697L9.25 12.1893L12.2197 9.21967C12.5126 8.92678 12.9874 8.92678 13.2803 9.21967Z\" fill=\"currentColor\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.51547 4.75C6.6385 3.76342 7.4801 3 8.5 3H11.5C12.5269 3 13.373 3.77394 13.487 4.77035C13.4862 4.76355 13.4854 4.75677 13.4845 4.75H13.75C14.9926 4.75 16 5.75736 16 7V14.75C16 15.9926 14.9926 17 13.75 17H6.25C5.00736 17 4 15.9926 4 14.75V7C4 5.75736 5.00736 4.75 6.25 4.75H6.51547ZM8.5 4.5H11.5C11.7761 4.5 12 4.72386 12 5V6C12 6.27614 11.7761 6.5 11.5 6.5H8.5C8.22386 6.5 8 6.27614 8 6V5C8 4.72386 8.22386 4.5 8.5 4.5ZM6.51304 6.22965C6.51382 6.23645 6.51463 6.24323 6.51547 6.25H6.25C5.83579 6.25 5.5 6.58579 5.5 7V14.75C5.5 15.1642 5.83579 15.5 6.25 15.5H13.75C14.1642 15.5 14.5 15.1642 14.5 14.75V7C14.5 6.58579 14.1642 6.25 13.75 6.25H13.4845C13.3615 7.23658 12.5199 8 11.5 8H8.5C7.4731 8 6.62695 7.22606 6.51304 6.22965Z\" fill=\"currentColor\"></path></svg>",
    "transito": "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 5.25C4 4.83579 4.33579 4.5 4.75 4.5H11.7414C12.9692 4.5 14.0483 5.31394 14.3856 6.49452L14.8125 7.98862C14.837 8.07452 14.9055 8.1408 14.9922 8.16247L16.6744 8.58303C17.4535 8.77779 18 9.47776 18 10.2808V11.5C18 12.2108 17.5763 12.8226 16.9676 13.0966C16.9889 13.2279 17 13.3627 17 13.5C17 14.8807 15.8807 16 14.5 16C13.1193 16 12 14.8807 12 13.5C12 13.4156 12.0042 13.3322 12.0123 13.25H8.98766C8.99582 13.3322 9 13.4156 9 13.5C9 14.8807 7.88071 16 6.5 16C5.11929 16 4 14.8807 4 13.5C4 13.1444 4.07422 12.8062 4.20802 12.5H3.75C3.33579 12.5 3 12.1642 3 11.75C3 11.3358 3.33579 11 3.75 11H6.25C6.27988 11 6.30935 11.0017 6.33831 11.0051C6.39177 11.0017 6.44568 11 6.5 11C7.19935 11 7.83163 11.2872 8.28536 11.75H12.7146C13.1684 11.2872 13.8007 11 14.5 11C15.1982 11 15.8296 11.2863 16.2832 11.7478C16.4056 11.7316 16.5 11.6268 16.5 11.5V10.2808C16.5 10.1661 16.4219 10.0661 16.3106 10.0382L14.6284 9.61769C14.0217 9.466 13.542 9.00205 13.3702 8.4007L12.9433 6.9066C12.79 6.36997 12.2995 6 11.7414 6H4.75C4.33579 6 4 5.66421 4 5.25ZM6.5 14.5C7.05228 14.5 7.5 14.0523 7.5 13.5C7.5 12.9477 7.05228 12.5 6.5 12.5C5.94772 12.5 5.5 12.9477 5.5 13.5C5.5 14.0523 5.94772 14.5 6.5 14.5ZM14.5 14.5C15.0523 14.5 15.5 14.0523 15.5 13.5C15.5 12.9477 15.0523 12.5 14.5 12.5C13.9477 12.5 13.5 12.9477 13.5 13.5C13.5 14.0523 13.9477 14.5 14.5 14.5Z\" fill=\"currentColor\"></path><path d=\"M3.25 8C2.83579 8 2.5 8.33579 2.5 8.75C2.5 9.16421 2.83579 9.5 3.25 9.5H8.25C8.66421 9.5 9 9.16421 9 8.75C9 8.33579 8.66421 8 8.25 8H3.25Z\" fill=\"currentColor\"></path></svg>",
    "consegna": "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 9C6.44772 9 6 9.44771 6 10V13C6 13.5523 6.44771 14 7 14H11C11.5523 14 12 13.5523 12 13V10C12 9.44772 11.5523 9 11 9H7ZM7.5 12.5V10.5H10.5V12.5H7.5Z\" fill=\"currentColor\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.31463 4.44946C5.73645 3.85394 6.4209 3.5 7.15068 3.5H12.9472C13.6995 3.5 14.402 3.87598 14.8193 4.50192L16.0381 6.33013C16.3393 6.78186 16.5 7.31263 16.5 7.85555V14.75C16.5 15.7165 15.7165 16.5 14.75 16.5H5.25C4.2835 16.5 3.5 15.7165 3.5 14.75V7.88657C3.5 7.31712 3.67678 6.76171 4.00593 6.29703L5.31463 4.44946ZM7.15068 5C6.90742 5 6.67927 5.11798 6.53866 5.31649L5.70034 6.5H9.25V5H7.15068ZM10.75 6.5H14.3486L13.5713 5.33397C13.4322 5.12533 13.198 5 12.9472 5H10.75V6.5ZM15 8H5V14.75C5 14.8881 5.11193 15 5.25 15H14.75C14.8881 15 15 14.8881 15 14.75V8Z\" fill=\"currentColor\"></path></svg>",
    "problema": "<svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.6668 6C11.081 6.00001 11.4168 6.3358 11.4168 6.75001L11.4167 10.25C11.4167 10.6642 11.0809 11 10.6667 11C10.2525 11 9.91668 10.6642 9.91669 10.25L9.91675 6.74999C9.91676 6.33577 10.2526 5.99999 10.6668 6Z\" fill=\"currentColor\"></path><path d=\"M11.6667 13C11.6667 13.5523 11.219 14 10.6667 14C10.1145 14 9.66675 13.5523 9.66675 13C9.66675 12.4477 10.1145 12 10.6667 12C11.219 12 11.6667 12.4477 11.6667 13Z\" fill=\"currentColor\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.6667 10C17.6667 13.866 14.5327 17 10.6667 17C6.80075 17 3.66675 13.866 3.66675 10C3.66675 6.13401 6.80075 3 10.6667 3C14.5327 3 17.6667 6.13401 17.6667 10ZM16.1667 10C16.1667 13.0376 13.7043 15.5 10.6667 15.5C7.62918 15.5 5.16675 13.0376 5.16675 10C5.16675 6.96243 7.62918 4.5 10.6667 4.5C13.7043 4.5 16.1667 6.96243 16.1667 10Z\" fill=\"currentColor\"></path></svg>"
  };

  var MESI = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
  function data(d) { // 2026-10-16 -> 16 ott 2026
    if (!d) return '';
    var p = d.split('-');
    return parseInt(p[2], 10) + ' ' + MESI[parseInt(p[1], 10) - 1] + ' ' + p[0];
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var TITOLI = {
    unfulfilled: 'Ordinato',
    pending: 'Ordine pronto',
    info_received: 'Informazioni ricevute',
    in_transit: 'In transito',
    out_for_delivery: 'In consegna',
    delivered: 'Consegnato',
    failed_attempt: 'Tentativo di consegna non riuscito',
    exception: 'Eccezione',
    canceled: 'Annullato'
  };
  var MESSAGGI = {
    unfulfilled: 'Questi articoli non sono stati ancora spediti.',
    pending: 'In attesa che il corriere aggiorni le informazioni di tracciamento. Riprova più tardi.',
    canceled: 'Siamo spiacenti, il tuo ordine è stato annullato. Se ritieni che si tratti di un errore, contatta il nostro team di supporto.'
  };

  /* ---------------------------------------------------------------- linguette */
  var linguette = radice.querySelectorAll('[data-linguetta]');
  var moduli = radice.querySelectorAll('[data-modulo]');
  function scegli(quale) {
    for (var i = 0; i < linguette.length; i++) {
      var on = linguette[i].getAttribute('data-linguetta') === quale;
      linguette[i].classList.toggle('is-attiva', on);
      linguette[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    for (var j = 0; j < moduli.length; j++) moduli[j].hidden = moduli[j].getAttribute('data-modulo') !== quale;
  }
  for (var i = 0; i < linguette.length; i++) {
    linguette[i].addEventListener('click', function () { scegli(this.getAttribute('data-linguetta')); });
  }

  /* ---------------------------------------------------------------- ricerca */
  function errore(input, mostra) {
    var e = input.parentNode.querySelector('.ppz-tr__errore');
    if (e) e.hidden = !mostra;
    input.setAttribute('aria-invalid', mostra ? 'true' : 'false');
  }

  var inCorso = null;
  function cerca(parametri, pulsante) {
    if (inCorso) inCorso.abort && inCorso.abort();
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    inCorso = ctl;
    risultato.innerHTML = '<div class="ppz-tr__attesa" aria-label="Caricamento"><span></span><span></span><span></span><span></span><span></span></div>';
    if (pulsante) pulsante.disabled = true;
    var q = Object.keys(parametri).map(function (k) { return k + '=' + encodeURIComponent(parametri[k]); }).join('&');
    fetch(API + '?' + q, { signal: ctl ? ctl.signal : undefined, credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (pulsante) pulsante.disabled = false;
        if (!d || !d.ok || !d.pacchi || !d.pacchi.length) return nonTrovato(d && d.errore);
        mostra(d, 0);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        if (pulsante) pulsante.disabled = false;
        nonTrovato('guasto');
      });
  }

  function nonTrovato(motivo) {
    var testo = motivo === 'guasto' || motivo === 'troppe'
      ? 'Non riusciamo a caricare il tracciamento in questo momento. Riprova tra qualche minuto.'
      : 'Ordine non trovato';
    risultato.innerHTML = '<div class="ppz-tr__nontrovato">' + esc(testo) + '</div>';
  }

  radice.querySelector('[data-modulo="ordine"]').addEventListener('submit', function (ev) {
    ev.preventDefault();
    var o = this.elements.ordine, c = this.elements.contatto;
    var vuotoO = !o.value.trim(), vuotoC = !c.value.trim();
    errore(o, vuotoO); errore(c, vuotoC);
    if (vuotoO || vuotoC) { risultato.innerHTML = ''; return; }
    cerca({ ordine: o.value.trim(), contatto: c.value.trim() }, this.querySelector('button'));
  });
  radice.querySelector('[data-modulo="numero"]').addEventListener('submit', function (ev) {
    ev.preventDefault();
    var n = this.elements.numero;
    var vuoto = !n.value.trim();
    errore(n, vuoto);
    if (vuoto) { risultato.innerHTML = ''; return; }
    var numero = n.value.trim().replace(/\s+/g, '');
    try {
      var u = new URL(location.href);
      u.searchParams.set('nums', numero);
      history.replaceState(null, '', u.toString());
    } catch (e) {}
    cerca({ nums: numero }, this.querySelector('button'));
  });
  var tutti = radice.querySelectorAll('.ppz-tr__input');
  for (var k = 0; k < tutti.length; k++) tutti[k].addEventListener('input', function () { if (this.value.trim()) errore(this, false); });

  /* ---------------------------------------------------------------- disegno */
  // Ogni passo: nome, data, e com'è il pallino: 'fatto' (✓ pieno), 'ora' (icona piena),
  // 'futuro' (icona vuota sbiadita), 'problema' (punto esclamativo, bordo tratteggiato).
  function passi(p) {
    var g = p.passi || {};
    var s = p.stato;
    // Fila lunga, quella del computer (come Track123): i 5 passi; con un problema
    // «Ordinato · Ordine pronto · In transito · <problema>». Il telefono ne mostra una parte.
    if (s === 'canceled') {
      return [
        { nome: 'Ordinato', data: g.ordinato, tipo: 'fatto', icona: 'ordinato' },
        { nome: TITOLI[s], data: g.problema || g.ordinato, tipo: 'problema', icona: 'problema' }
      ];
    }
    var ordine = ['ordinato', 'pronto', 'transito', 'consegna', 'consegnato'];
    var nomi = { ordinato: 'Ordinato', pronto: 'Ordine pronto', transito: 'In transito', consegna: 'In consegna', consegnato: 'Consegnato' };
    if (s === 'failed_attempt' || s === 'exception') {
      return ['ordinato', 'pronto', 'transito'].map(function (k) {
        return { nome: nomi[k], data: g[k], tipo: 'fatto', icona: k };
      }).concat([{ nome: TITOLI[s], data: g.problema || g.transito || g.ordinato, tipo: 'problema', icona: 'problema' }]);
    }
    var adesso = { unfulfilled: 'ordinato', pending: 'pronto', info_received: 'pronto', in_transit: 'transito', out_for_delivery: 'consegna', delivered: 'consegnato' }[s] || 'pronto';
    var iAdesso = ordine.indexOf(adesso);
    return ordine.map(function (k, i) {
      return {
        nome: nomi[k],
        data: i <= iAdesso ? g[k] : '',
        tipo: i < iAdesso || s === 'delivered' ? 'fatto' : (i === iAdesso ? 'ora' : 'futuro'),
        icona: k === 'consegnato' ? 'fatto' : k
      };
    });
  }

  // Sul telefono: il primo passo, quello in corso e il successivo (regola vista su Track123:
  // «Ordinato · In transito · In consegna», «Ordinato · In consegna · Consegnato»,
  // «Ordinato · In transito · <problema>»); consegnato = «Ordinato · Consegnato».
  function finestraTelefono(fila, stato) {
    if (stato === 'delivered') return [fila[0], fila[fila.length - 1]];
    if (fila.length <= 3) return fila;
    var c = -1;
    for (var i = 0; i < fila.length; i++) if (fila[i].tipo === 'ora' || fila[i].tipo === 'problema') c = i;
    if (c <= 0) return fila.slice(0, 3);
    if (c >= fila.length - 1) return [fila[0], fila[fila.length - 2], fila[fila.length - 1]];
    return [fila[0], fila[c], fila[c + 1]];
  }

  function htmlPassi(fila, dove) {
    var h = '<div class="ppz-tr__passi ppz-tr__passi--' + dove + '"><div class="ppz-tr__fila">';
    fila.forEach(function (x, i) {
      var vuoto = '<span class="ppz-tr__punto-vuoto' + (x.tipo === 'problema' ? ' is-problema' : '') + '">' + ICONE[x.icona] + '</span>';
      var pieno = '';
      if (x.tipo === 'fatto') pieno = '<span class="ppz-tr__punto-pieno">' + ICONE.fatto + '</span>';
      if (x.tipo === 'ora') pieno = '<span class="ppz-tr__punto-pieno">' + ICONE[x.icona] + '</span>';
      var raggiunto = x.tipo !== 'futuro';
      h += '<div class="ppz-tr__passo"><div class="ppz-tr__punto">' + vuoto + pieno +
        '<div class="ppz-tr__didascalia"><span class="ppz-tr__nome' + (raggiunto ? '' : ' is-futuro') + '">' + esc(x.nome) + '</span>' +
        (raggiunto && x.data ? '<span class="ppz-tr__data">' + esc(data(x.data)) + '</span>' : '') + '</div></div>';
      if (i < fila.length - 1) {
        var dopo = fila[i + 1];
        h += '<div class="ppz-tr__linea' + (dopo.tipo === 'fatto' || dopo.tipo === 'ora' || dopo.tipo === 'problema' ? ' is-piena' : '') + '"></div>';
      }
      h += '</div>';
    });
    return h + '</div></div>';
  }

  var PRIME = 3; // righe visibili prima di «Mostra cronologia», come Track123
  function htmlEventi(eventi, tutti) {
    var h = '';
    var giorno = null;
    var mostrati = tutti ? eventi : eventi.slice(0, PRIME);
    mostrati.forEach(function (e, i) {
      if (e.d !== giorno) {
        if (giorno !== null) h += '</div>';
        h += '<h3 class="ppz-tr__h3">' + (giorno === null ? 'Ultimo aggiornamento ' : '') + esc(data(e.d)) + '</h3><div class="ppz-tr__gruppo">';
        giorno = e.d;
      }
      var testo = (e.luogo ? e.luogo + ', ' : '') + e.testo;
      h += '<div class="ppz-tr__evento"><div class="ppz-tr__testo' + (i === 0 ? ' is-primo' : '') + '">' + esc(testo) + '</div>' +
        '<div class="ppz-tr__ora">' + esc(e.t) + '</div></div>';
    });
    if (giorno !== null) h += '</div>';
    return h;
  }

  function htmlArticoli(articoli) {
    return articoli.map(function (a) {
      return '<div class="ppz-tr__articolo">' +
        '<div class="ppz-tr__foto">' + (a.immagine ? '<img src="' + esc(a.immagine) + '" alt="" width="58" height="58" loading="lazy">' : '') + '</div>' +
        '<div class="ppz-tr__articolo-dx"><div class="ppz-tr__titolo">' + esc(a.titolo) + '</div>' +
        '<div class="ppz-tr__variante">' + (a.variante ? '<span class="ppz-tr__chip">' + esc(a.variante) + '</span>' : '') + '<span>x' + esc(a.quantita) + '</span></div>' +
        (a.url ? '<a class="ppz-tr__riordina" href="' + esc(a.url) + '">Riordina</a>' : '') +
        '</div></div>';
    }).join('');
  }

  function mostra(d, n) {
    var p = d.pacchi[n];
    var h = '<div class="ppz-tr__sezione">';
    if (d.pacchi.length > 1) {
      h += '<div class="ppz-tr__pacchi"><div class="ppz-tr__pacchi-titolo">L\'ordine ha ' + d.pacchi.length + ' pacchi</div>';
      d.pacchi.forEach(function (x, i) {
        h += '<button type="button" class="ppz-tr__pacco' + (i === n ? ' is-attivo' : '') + '" data-pacco="' + i + '">Pacco ' + (i + 1) + '</button>';
      });
      h += '</div>';
    }
    h += '<div class="ppz-tr__testa"><div class="ppz-tr__ordine">Ordine: ' + esc(d.ordine) + '</div></div>';
    h += '<div class="ppz-tr__statobox"><h1 class="ppz-tr__stato">' + esc(TITOLI[p.stato] || 'In transito') + '</h1></div>';
    var fila = passi(p);
    h += htmlPassi(finestraTelefono(fila, p.stato), 'telefono') + htmlPassi(fila, 'computer');
    h += '</div>';

    h += '<div class="ppz-tr__corpo"><div class="ppz-tr__dettagli"><h2 class="ppz-tr__h2">Dettagli della spedizione</h2>';
    if (MESSAGGI[p.stato]) h += '<p class="ppz-tr__messaggio">' + esc(MESSAGGI[p.stato]) + '</p>';
    h += '<div data-eventi>' + htmlEventi(p.eventi || [], false) + '</div>';
    if ((p.eventi || []).length > PRIME) {
      h += '<div class="ppz-tr__altro-box"><button type="button" class="ppz-tr__altro" data-altro aria-expanded="false">Mostra cronologia</button></div>';
    }
    h += '</div><div class="ppz-tr__pacco-info"><h2 class="ppz-tr__h2">Informazioni sul pacco</h2><div class="ppz-tr__info">';
    if (p.destinazione) {
      h += '<div><h3 class="ppz-tr__h3">Destinazione</h3><div class="ppz-tr__mappa"><iframe title="Mappa della destinazione" loading="lazy" referrerpolicy="no-referrer-when-downgrade" src="https://maps.google.com/maps?q=' +
        encodeURIComponent(p.destinazione) + '&z=11&hl=it&output=embed"></iframe></div></div>';
    }
    if ((p.articoli || []).length) {
      h += '<div><h3 class="ppz-tr__h3">Contenuto del pacco</h3>' + htmlArticoli(p.articoli) + '</div>';
    }
    h += '</div></div></div>';
    risultato.innerHTML = h;

    var altro = risultato.querySelector('[data-altro]');
    if (altro) {
      altro.addEventListener('click', function () {
        var aperto = this.getAttribute('aria-expanded') === 'true';
        risultato.querySelector('[data-eventi]').innerHTML = htmlEventi(p.eventi, !aperto);
        this.setAttribute('aria-expanded', aperto ? 'false' : 'true');
        this.textContent = aperto ? 'Mostra cronologia' : 'Nascondi cronologia';
      });
    }
    var bottoni = risultato.querySelectorAll('[data-pacco]');
    for (var i = 0; i < bottoni.length; i++) {
      bottoni[i].addEventListener('click', function () { mostra(d, parseInt(this.getAttribute('data-pacco'), 10)); });
    }
  }

  /* ---------------------------------------------------------------- avvio con ?nums= */
  var parametri = new URLSearchParams(location.search);
  var nums = (parametri.get('nums') || '').trim();
  if (nums) {
    nums = nums.split(',')[0].replace(/\s+/g, '');
    scegli('numero');
    var campo = radice.querySelector('#ppz-tr-numero');
    campo.value = nums;
    cerca({ nums: nums }, radice.querySelector('[data-modulo="numero"] button'));
  }
})();
